import uk from './uk'
import Utils from '../Utils'

var ukMsg = {
  'agreements.title': 'Підтвердження згоди',
  'agreements.error.mandatory': "Щоб і надалі користуватися послугами Deeper, необхідно підтвердити свою згоду",
  'agreements.error.blank': "Зробіть свій вибір",
  'agreements.back': 'Назад',
  'agreements.agree': 'Погодитись',
  'agreements.decline': 'Відхилити',
  'agreements.text.full': 'Повна згода'
}

Utils.addTerms(ukMsg, uk)

export default ukMsg



// WEBPACK FOOTER //
// ./src/lang/ukMsg.js